<template>
  <div class="field-wrapper">
    <PeriodSelector
      v-model="period"
      :units="units"
      title="automatedScenarios.fields.delay"
    />
    <FieldErrors
      :key="componentFieldErrorsKey"
      :errors="formValidation"
      field="time_unit_select"
    />
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';
import { PeriodSelector } from '@/components/flows/operators/shared';
import {
  defineComponent,
  PropType,
  ref,
  watch,
} from 'vue';
import { asInt } from '@/helpers';
import FieldErrors from '@/components/fields/partials/FieldErrors.vue';
import type { Period } from '@/types/flow-types';
import type { DelaisMaxData } from './index';

export default defineComponent({
  name: 'DelaisMaxForm',

  components: {
    FieldErrors,
    PeriodSelector,
  },

  props: {
    modelValue: {
      type: Object as PropType<DelaisMaxData>,
      required: true,
    },
    formValidation: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const { t } = useI18n();
    const componentFieldErrorsKey = ref(0);

    watch(() => props.formValidation, () => {
      componentFieldErrorsKey.value += 1;
    });

    const units = [
      { value: 'SECOND', label: t('automatedScenarios.fields.durations.second(s)') },
      { value: 'MINUTE', label: t('automatedScenarios.fields.durations.minute(s)') },
      { value: 'HOUR', label: t('automatedScenarios.fields.durations.hour(s)') },
      { value: 'DAY', label: t('automatedScenarios.fields.durations.day(s)') },
    ];

    const period = ref<Period>({
      unit: props.modelValue.time_unit_select.unit,
      value: asInt(props.modelValue.time_unit_select.value),
    });

    watch(period, (newValue) => {
      emit('update:modelValue', {
        ...props.modelValue,
        time_unit_select: {
          value: newValue.value,
          unit: newValue.unit,
        },
      });
    }, { deep: true });

    return {
      componentFieldErrorsKey,
      units,
      period,
    };
  },
});
</script>

<style lang="scss" scoped>
.field-wrapper {
  margin-bottom: 1rem;
}
</style>
